<div class="breadcrumbs">
    <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right
        </mat-icon> Gestione segnalazioni
        <mat-icon style="vertical-align: middle;">
            keyboard_arrow_right
        </mat-icon>
        <span *ngIf="fromDettaglioPage">Dettaglio segnalazione</span>
        <span *ngIf="fromModificaPage">Modifica segnalazione</span>
        <span *ngIf="fromDettaglioPage==false && fromModificaPage==false">Compila segnalazione</span>
        <mat-icon style="vertical-align: middle;">
            keyboard_arrow_right
        </mat-icon>
        <span>Storico segnalazione</span>
    </span>
</div>
<hr>
<div class="titolo flex-display">
    <div class="flex-display">
        <button mat-stroked-button class="pers" (click)="previousPage()">
            <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
        </button>
        <div class="denom">
            <span class="h1 upp">Storico segnalazione {{this.codiceSegnalazione}}</span>
        </div>
    </div>
</div>

<br>

<mat-table [dataSource]="dataSource" matSort matSortActive="codiceSegnalazione" matSortDirection="asc"
  matSortDisableClear>

  <ng-container matColumnDef="storicizzazione">
    <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="acl == 'eell'"> Data/Ora storicizzazione </mat-header-cell>
    <mat-cell [attr.data-label]="'STORICIZZAZIONE'" *matCellDef="let element" [hidden]="acl == 'eell'">
      {{this.datePipe.transform(element.dataStoricizzazione, 'dd/MM/yyyy HH:mm:ss')}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stato">
    <mat-header-cell *matHeaderCellDef> Stato </mat-header-cell>
    <mat-cell [attr.data-label]="'STATO'" *matCellDef="let element">
      <span *ngIf="element.stato == 'BOZ'">In bozza</span>
      <span *ngIf="element.stato == 'COM'">Completata</span>
      <span *ngIf="element.stato == 'INV'">Inviata</span>
      <span *ngIf="element.stato == 'RIC'">Ricevuta</span>
      <span *ngIf="element.stato == 'NOR'">Non ricevuta</span>
      <span *ngIf="element.stato == 'CON'">Confermata</span>
      <span *ngIf="element.stato == 'RIF'">Rifiutata</span>
      <span *ngIf="element.stato == 'IDI'">Inviata al dipartimento</span>
      <span *ngIf="element.stato == 'ENR'">Emergenza non riconosciuta</span>
      <span *ngIf="element.stato == 'IDG'">Inviata a DGPE</span>
      <span *ngIf="element.stato == 'BPE'">In bozza</span>
      <span *ngIf="element.stato == 'APP'">Apertura post emergenza</span>
      <span *ngIf="element.stato == 'INP'">Inviata post emergenza</span>
      <span *ngIf="element.stato == 'CHI'">Chiusa post emergenza</span>
      <span *ngIf="element.stato == 'RIP'">Ricevuta</span>
      <span *ngIf="element.stato == 'COP'">Completata</span>
      <span *ngIf="element.stato == 'CNP'">Confermata post emergenza</span>
      <span *ngIf="element.stato == 'RFP'">Rifiutata</span>
      <span *ngIf="element.stato == 'IPE'">Inviata al dipartimento post emergenza</span>
      <span *ngIf="element.stato == 'IDP'">Inviata al dipartimento DGPE post emergenza</span>
      <span *ngIf="element.stato == 'INT'">Richiesta Integrazione</span>
      <span *ngIf="element.stato == 'ITP'">Richiesta Integrazione post emergenza</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataUltimaModifica">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data ultima modifca </mat-header-cell>
    <mat-cell [attr.data-label]="'DATAULTIMODIFICA'" *matCellDef="let element">
      {{this.datePipe.transform(element.dtUltimaModifica, 'dd/MM/yyyy HH:mm:ss')}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="utenteUltimaModifica">
    <mat-header-cell *matHeaderCellDef> Utente ultima modifca </mat-header-cell>
    <mat-cell [attr.data-label]="'UTENTEULTIMAMODIFICA'" *matCellDef="let element">
      {{element.utenteUltimaModifica}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Azioni </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span *ngIf="element.dataStoricizzazione !== openToggle" class="material-icons" title="apri/chiudi toolbar"
        (click)="openToggle = element.dataStoricizzazione">more_horiz</span>
      <myp-toolbar *ngIf="element.dataStoricizzazione === openToggle" [toolbar]="toolbar" role=toolbar [data]="element"
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.segnalazioneStoricoSubject.value.length == 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>
